import React from 'react';
import { ReportWidgetLoader } from '../ReportWidgetLoader';
import { ExecutiveSummaryTable, ExecutiveSummaryTableColumn } from '@src/components/features/reports-and-logs/executive-summary/ExecutiveSummaryTable/ExecutiveSummaryTable';
import { Link } from 'react-router-dom';
import ArrowRight from '@svg/arrow-right-blue.svg?react';
import './BlockedThreatsBySeverityWidget.scss';
import { BarChartBar } from 'src/components/shared/BarChartBar/BarChartBar';
import TrendPercentIndicator
    from '@src/components/shared/TrendPercentIndicator/TrendPercentIndicator';
import { BaseWidgetProps } from '../types';
import { Direction, ReportName } from '@src/utils/enums';
import { formatNumber } from '@src/utils/number-util';

interface BlockedThreatsBySeverityRow {
  severity: 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW' | 'INFO';
  count: number;
  trendPercent: number;
}

const BTS_TABLE_COLUMNS: ExecutiveSummaryTableColumn[] = [
  { key: 'severity', label: 'Severity' },
  { key: 'count', label: 'Count' },
  { key: 'trend', label: '' },
  { key: 'block', label: '% Blocks' },
  { key: 'bar', label: '' },
];

export const BlockedThreatsBySeverityWidget: React.FC<BaseWidgetProps> = (props) => {
  return (
    <ReportWidgetLoader hookProps={{ ...props, reportName: 'blockedThreatsBySeverity' }}>
      {(data, error) => {
        const rows: BlockedThreatsBySeverityRow[] = data || [];
        const maxCount = rows.length > 0 ? Math.max(...rows.map(r => r.count)) : 1;
        const totalCount = rows.reduce((sum, r) => sum + r.count, 0) || 1;
        const renderRow = (row: BlockedThreatsBySeverityRow) => (
          <div className="es-tr" key={row.severity}>
            <div className="es-td bts-td-severity">
              <span className={`bts-dot bts-dot-${row.severity.toLowerCase()}`}></span>
              <span className="bts-severity-label">{row.severity}</span>
            </div>
            <div className="es-td bts-td-count">
                <div>{formatNumber(row.count)}</div>
        <TrendPercentIndicator
          trendPercent={row.trendPercent}
          showTrendDirectionText={false} />
            </div>
            <div className="es-td bts-td-block">
              {((row.count / totalCount) * 100).toFixed(1)}%
            </div>
            <BarChartBar
                  bgClassName="es-td"
                  widthPercent={maxCount > 0 ? (row.count / maxCount) * 100 : 0}
                  className={`severity-${row.severity.toLowerCase()}`}
            />
          </div>
        );
        return (
          <div className="blocked-threats-by-severity-widget">
            <div className="bts-header">
                <div className="bts-header-title">
                  <div className="widget-title">Blocked threats by severity</div>
                  <span className="premium-tag">PREMIUM</span>
                </div>
                 <Link className="widget-link"
                       to={`/${props.customerId}/${props.serviceId}/insights/reports/${ReportName.TOP_15_DETECTED_THREATS}`}
                       state={{ direction: Direction.Outbound }}>
                    <span>Detected threats</span><ArrowRight/>
                 </Link>
            </div>
            <ExecutiveSummaryTable
              columns={BTS_TABLE_COLUMNS}
              data={rows}
              renderRow={renderRow}
              className="bts-table"
              hasError={!!error}
            />
          </div>
        );
      }}
    </ReportWidgetLoader>
  );
};
